var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronRightWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9337,
    cy: 16.9336,
    r: 16.3691,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0632 15.9688C10.5109 15.9688 10.0632 16.4165 10.0632 16.9688C10.0632 17.521 10.5109 17.9688 11.0632 17.9688V15.9688ZM23.5802 17.6759C23.9708 17.2853 23.9708 16.6522 23.5802 16.2616L17.2163 9.89768C16.8257 9.50716 16.1926 9.50716 15.8021 9.89768C15.4115 10.2882 15.4115 10.9214 15.8021 11.3119L21.4589 16.9688L15.8021 22.6256C15.4115 23.0161 15.4115 23.6493 15.8021 24.0398C16.1926 24.4303 16.8257 24.4303 17.2163 24.0398L23.5802 17.6759ZM11.0632 17.9688H22.8731V15.9688H11.0632V17.9688Z",
    fill: "#3661FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightWhite);
export default __webpack_public_path__ + "static/media/chevron-right-white.926eb0091cca68e7b4c90f1e242467da.svg";
export { ForwardRef as ReactComponent };